import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { setContext } from '@apollo/client/link/context';
import { BrowserPersistence } from '@magento/peregrine/lib/util';
var storage = new BrowserPersistence();
export default function createStoreLink() {
  return setContext(function (_, _ref) {
    var headers = _ref.headers;
    var storeCurrency = storage.getItem('store_view_currency') || null;
    var storeCode = storage.getItem('store_view_code') || STORE_VIEW_CODE; // return the headers to the context so httpLink can read them

    return {
      headers: _objectSpread({}, headers, {
        store: storeCode
      }, storeCurrency && {
        'Content-Currency': storeCurrency
      })
    };
  });
}